import { withStyles } from '@material-ui/core/styles';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomFormView from '../../../../../shared/custom-form-view/Custom-Form-View';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  addInRoomDiningCustomisation,
  editInRoomDiningCustomisation,
} from '../../../../../utils/ServicesAPIUtils';
import { fetchAllInRoomDining } from '../../../servicesSlice';
import './Customisation-Create.scss';
import { formDataValidate } from '../../../../../utils/formUtils';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const InRoomDiningCustomisationCreate = (props) => {
  const { toggleDrawer, customisation, hotelId, restaurantId } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required', 'maxLength'],
      maxLength: 100,
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      maxLength: 30,
      tab: 0,
    },
    status: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    if (customisation) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = customisation[field];
      }
      currFields.customAttributes.value = customisation.customAttributes || [];
    }
  }, [customisation]);

  const handleSubmit = async (e) => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      e.preventDefault();
      toggleDrawer('', false, '');
      setLoading(true);
      let payload = {
        name: formData.name.value,
        code: formData.code.value,
        status: formData.status.value,
        hotelId,
        restaurantId,
        customAttributes: formData.customAttributes.value,
      };
      if (customisation?.id) {
        payload.id = customisation?.id;
        await editInRoomDiningCustomisation(payload, language);
      } else {
        await addInRoomDiningCustomisation(payload, language);
      }
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager(
        'success',
        `Customisation ${customisation ? 'updated' : 'created'} successfully`,
      );
      setLoading(true);
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors?.[0]?.message
          : `Customisation not ${customisation ? 'updated' : 'created'}`,
      );
      setLoading(false);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onCancel = () => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <CustomFormView
      handleSubmit={handleSubmit}
      tabTitle={[]}
      onCancel={onCancel}
      tabValue={0}
      maxtab={0}
      isUpdate={customisation ? true : false}
      loading={loading}
      title={`${customisation ? 'Edit' : 'Add'} Customisation`}
      titleClass='col-md-11'
      isTabInValid={isTabInValid}
      tabClass=''
      cancelClass='col-md-1 '
    >
      <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
        <div className='col-md-12 mb-3'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                maxLength={60}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
        </div>
        <div className='row w-100 '>
          <div className='col-auto d-inline-flex align-items-center'>
            <CustomCheckbox
              item={formData.status}
              handleInputChange={(e) => setFormData({ status: e })}
              color='primary'
            />
            <CustomToolTip title='Deactivating this, hides it from Guest app' placement='right'>
              <InfoIcon fontSize='small' /> 
            </CustomToolTip>
          </div>
        </div>
        <KeyValuePairList
          item={formData.customAttributes}
          onListChange={(e) => {
            setFormData({ customAttributes: e });
          }}
        />
      </div>
    </CustomFormView>
  );
};

export default InRoomDiningCustomisationCreate;
